import apiClient from "../../utils/api.client";

const getProvinces = async (country) => {
  // return fetch(`${getServiceUrl()}/provinces?pageNumber=${1}&pageSize=${1}&orderCriteria=DESC&orderField=name&countryId=${country || 11}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" },
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw res.status
  //     }
  //   })
  //   .then(json => {
  //     return fetch(`${getServiceUrl()}/provinces?pageNumber=${1}&pageSize=${json.totalElements}&orderCriteria=DESC&orderField=name&countryId=${country || 11}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json", "accept": "application/json" },
  //     })
  //       .then(response => response.json())
  //       .then(data => data)
  //   })
  //   .catch(e => {
  //     throw e
  //   })
  try {
    const url = `/location-service/provinces?pageNumber=${1}&pageSize=${100}&orderCriteria=DESC&orderField=name&countryId=${country || 1}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getProvince EP: ", error);
    throw error;
  }
};

const getCities = async (province) => {
  // return fetch(`${getServiceUrl()}/locations?pageNumber=${1}&pageSize=${1}&orderCriteria=DESC&orderField=name&provinceId=${province || 0}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" },
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw res.status
  //     }
  //   })
  //   .then(json => {
  //     return fetch(`${getServiceUrl()}/locations?pageNumber=${1}&pageSize=${json.totalElements}&orderCriteria=DESC&orderField=name&provinceId=${province || 0}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json", "accept": "application/json" },
  //     })
  //       .then(response => response.json())
  //       .then(data => data)
  //   })
  //   .catch(e => {
  //     throw e
  //   })
  try {
    const url = `/location-service/locations?pageNumber=${1}&pageSize=${200}&orderCriteria=DESC&orderField=name&provinceId=${province || 0}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getCities EP: ", error);
    throw error;
  }
};

const placesService = {
  getProvinces,
  getCities,
};

export default placesService;
